<template>
  <div class="container pull-up">
    <div class="loyalty-index">
      <loyalty-program-list
        ref="programList"
        @program-selected="handleProgramSelected"
        @edit-program="showEditForm"
        @program-deleted="handleProgramDeleted">
      </loyalty-program-list>

      <loyalty-program-form
        :visible="showForm"
        :program="selectedProgram"
        @saved="handleProgramSaved"
        @cancelled="closeForm">
      </loyalty-program-form>
    </div>
  </div>
</template>

<script>
import LoyaltyProgramList from './LoyaltyProgramList.vue'
import LoyaltyProgramForm from './LoyaltyProgramForm.vue'

export default {
  name: 'LoyaltyIndex',
  components: {
    LoyaltyProgramList,
    LoyaltyProgramForm
  },
  data () {
    return {
      showForm: false,
      selectedProgram: null
    }
  },
  mounted () {
    this.$emit('parent-title', this.$t('loyalty.name'))
    this.setParentHeaderAction()
  },
  beforeDestroy () {
    this.$emit('clear-header-action')
  },
  methods: {
    setParentHeaderAction () {
      this.$emit('set-header-action', {
        label: this.$t('loyalty.button.create'),
        icon: 'mdi mdi-plus',
        onClick: () => this.showCreateForm()
      })
    },
    showCreateForm () {
      this.selectedProgram = null
      this.showForm = true
    },
    showEditForm (program) {
      this.selectedProgram = program
      this.showForm = true
    },
    closeForm () {
      this.showForm = false
      this.selectedProgram = null
    },
    handleProgramSaved (program) {
      this.closeForm()
      // Refresh the list
      this.$nextTick(() => {
        if (this.$refs.programList) {
          this.$refs.programList.loadPrograms()
        }
      })
    },
    handleProgramSelected (programId) {
      // Navigate to program details or manage view
      if (programId) {
        this.$router.push({
          name: 'loyalty-program-manage',
          params: { id: programId }
        })
      }
    },
    handleProgramDeleted (programId) {
      // Program deleted, list will refresh automatically
    }
  }
}
</script>

<style scoped>
</style>
